import { REMOVE_INGREDIENTS_FROM_GROCERY_WAITLIST } from "./actionTypes";

export default (id) => ({
  type: REMOVE_INGREDIENTS_FROM_GROCERY_WAITLIST,
  payload: {
    id,
  }
});
